import { render } from "./AwardResult.vue?vue&type=template&id=87391c36"
import script from "./AwardResult.vue?vue&type=script&lang=js"
export * from "./AwardResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rydercook/Documents/Project Development/Award Slider/awardslider/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__